import { Modal, ModalBody, ModalFooter } from "react-bootstrap"
import Button from "../../form-components/Button";

const SummaryPromptRetrainDocuments = ({
  isVisible,
  toggleFunction,
  onRetrainDocuments,
}) => {
  return (
    <>
      <Modal
        data-bs-keyboard="false"
        onHide={toggleFunction}
        show={isVisible}
        className="modal fade"
        centered={true}
        dialogClassName="common-modal"
        backdrop="static"
      >
        <ModalBody>
          Your summary prompt has been updated. Would you want to re-train your documents?
        </ModalBody>
        <ModalFooter>
          <Button
            type="button"
            className="btn"
            onClick={toggleFunction}
          >
            No
          </Button>
          <Button
            type="button"
            className="btn btn-primary-md"
            onClick={onRetrainDocuments}
          >
            Yes
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default SummaryPromptRetrainDocuments;
